import { Box, Button, FormHelperText, Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import DlspDesktopQAForm from "./DlspDesktopQAForm"
import { DesktopQADetails } from "./DesktopQADetails"
import useFetchJson from "../../../data/useFetchJson"
import { LoadingBox } from "@northpowerdev/np-react-utils"
import { MahiContext, mahiNameFromMahiContext } from "../../state/MahiContext"

export function DlspDesktopQAPanel({taskDetails, assignee, onEdited, userName, isQARole, fspStatusNoEdit}) {
    const [isEditing, setIsEditing] = useState(false)
    const [qaOwner, setQAOwner] = useState('')
    const mahiContext = useContext(MahiContext)

    const claimDesktopQAPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/claim-desktop-qa-ownership'
    const {
        isLoading: isClaimingDesktopQA,
        load: claimDesktopQA} = useFetchJson(claimDesktopQAPath, {method: 'POST'}) 

    
    useEffect(() => {
        if (!taskDetails) {
            return
        }
        setQAOwner(taskDetails.decomICP?.desktopQAOwner || '')
    }, [taskDetails])

    const desktopQAButtonLabel = taskDetails?.decomICP?.desktopQA
        ? "Edit Desktop QA"
        : "Create Desktop QA"

    const handleDesktopQAFormEdited = () => {
        setIsEditing(false)
        onEdited() // tell parent the assessment form has been editied (even though it might just have been closed)
    }

    const handleDesktopQAEditStart = async () => {
        const fetchParams = { params: { icp: taskDetails.decomICP.icp } }
        const claimedOK = await claimDesktopQA(fetchParams)
        if (claimedOK !== undefined) {
            const mahiName = mahiNameFromMahiContext(mahiContext)
            setIsEditing(true)
            setQAOwner(mahiName)
        }
    }

    const isQAOtherOwner = qaOwner && qaOwner !== userName
    const qaButtonHelperText = qaOwner ? `Owned by ${qaOwner}` : ''
    return (
        <Box>
            {
                isEditing
                ?
                <DlspDesktopQAForm
                    desktopQADetails={taskDetails?.decomICP?.desktopQA}
                    statusHistory={taskDetails?.statusHistory}
                    icpNumber={taskDetails?.decomICP?.icp}
                    assignee={assignee}
                    onClose={handleDesktopQAFormEdited}
                    />
                :
                <>
                    <DesktopQADetails
                        desktopQA={taskDetails?.decomICP?.desktopQA}
                        desktopQAOwner={qaOwner}
                        desktopQABy={taskDetails?.decomICP?.desktopQABy}
                        desktopQADate={taskDetails?.decomICP?.desktopQADate}
                    />
                    <LoadingBox loading={isClaimingDesktopQA} message="Checking ownership...">
                        <Stack direction="row" justifyContent="space-between">
                            <Button variant="contained" disabled={isQAOtherOwner || fspStatusNoEdit} sx={{my:1}} color="primary" onClick={handleDesktopQAEditStart} >
                                {desktopQAButtonLabel}
                            </Button>
                            {
                                isQARole
                                &&
                                <Button variant="text" sx={{my:1}} color="secondary" disabled={fspStatusNoEdit} onClick={handleDesktopQAEditStart} >
                                    Become QA Owner
                                </Button>
                            }
                        </Stack>
                    </LoadingBox>
                </>
            }
            {
                qaButtonHelperText
                &&
                <FormHelperText>{qaButtonHelperText}</FormHelperText>
            }
        </Box>
    )
}
